import { render, staticRenderFns } from "./ReleasesForm.vue?vue&type=template&id=32ae7f31&scoped=true"
import script from "./ReleasesForm.vue?vue&type=script&lang=js"
export * from "./ReleasesForm.vue?vue&type=script&lang=js"
import style0 from "./ReleasesForm.vue?vue&type=style&index=0&id=32ae7f31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ae7f31",
  null
  
)

export default component.exports